import { Capacitor } from "@capacitor/core";

export enum PLATFORM {
  ANDROID = "android",
  IOS = "ios"
}

export const useIsNative = () => {
  return Capacitor.isNativePlatform();
};
